import { createContext } from 'react'

export const BidHistoryTooltipSuppressionContext = createContext<
    ((suppressed: boolean) => void) | undefined
>(undefined)
